import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function LatestArticles() {
  const latest = articles.slice(0, 6);

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between mb-12 gap-4">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">最新文章</h2>
            <p className="text-sm text-foreground-600">持续更新的深度内容，陪伴你的情感成长之路。</p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {latest.map((article) => (
            <article key={article.slug} className="group bg-background-100 rounded-lg border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300">
              <Link to={`/article/${article.slug}`} className="block">
                <div className="relative overflow-hidden aspect-[16/10]">
                  <img
                    src={article.imageUrl}
                    alt={article.title}
                    title={article.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-5">
                  <div className="flex items-center gap-3 text-xs text-foreground-500 mb-2 flex-wrap">
                    <span className="bg-secondary-100 text-secondary-800 px-2.5 py-0.5 rounded-full whitespace-nowrap">
                      {article.categoryName}
                    </span>
                    <span>{article.date}</span>
                    <span>{article.readTime}</span>
                  </div>
                  <h3 className="font-heading text-base text-foreground-950 mb-2 group-hover:text-primary-500 transition-colors duration-200 line-clamp-2">
                    {article.title}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">{article.excerpt}</p>
                </div>
              </Link>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}